import react, {useState} from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const ProfileImage = ({ photoUrl, className }: { photoUrl: string, className: string }) => {
    const [imageError, setImageError] = useState(false);
  
    const handleImageError = () => {
      console.error('Failed to load profile image');
      setImageError(true);
    };
  
    if (!photoUrl || imageError) {
      return <AccountCircleIcon className={className} />;
    }
  
    return (
      <img 
        src={photoUrl}
        alt="profile"
        className={className}
        onError={handleImageError}
      />
    );
  };

  export default ProfileImage;